/**
 * Created by andreyna on 6/8/2016.
 */
const REMINDER_SETTINGS_SELECTORS = {
    REMINDER_OPTIONS: '.cgp-reminder-select',
    CLOSE_BUTTON: '.cgp-reminder-cancel-btn',
    SAVE_BUTTON: '.cgp-reminder-save-btn',
    MORE_INFO_CONTAINER: '.cgp-reminder-text',
    MORE_INFO_SWITCH: '.cgp-more-info-title',
    REMINDER_INFO: '.cgp-reminder-info',
    REMINDER_INFO_MOBILE:  '.cgp-mobile:not(.cgp-tablet) .cgp-reminder-info'

};

const REMINDER_MORE_INFO_GAP = 25; // 15px - gap between button area top + 10px - info element margin

export {REMINDER_SETTINGS_SELECTORS, REMINDER_MORE_INFO_GAP};